spApp.filter('gradeFilter', [() => {
  const hasGrade = gradeId => ({ grades }) => grades.some(item => item.id === gradeId);

  return  (inputArray, gradeId) => {
    return !gradeId
      ? inputArray
      : inputArray.filter(hasGrade(gradeId))
  };
}]);
